import React, {useCallback, useContext, useEffect, useState} from 'react';
import Grid from "@mui/material/Grid";
import {AnagraficaCompleta} from "../../../../widgets/common/AnagraficaCompleta";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {AnagraficaContext, AppContext} from "../../../../../App";
import {
	AccordionActions,
	AccordionDetails,
	Backdrop,
	Button, CircularProgress,
	DialogActions,
	TextField,
	Tooltip
} from "@mui/material";
import {setOpenSnackbar} from "../../../../../services/AppServices";
import {generateIntervistaIncompleta, setIntervista} from "../../../../../services/IntervistaServices";
import {updateTampone} from "../../../../../services/TamponiServices";
import {addAnagrafica, resetGetAnagfrafica, updateAnagrafica} from "../../../../../services/AnagraficaServices";
import {useFormContext} from "react-hook-form";
import {useHistory, useParams} from "react-router-dom";
import {IntervistaContext, TamponiContext} from "../IntervistaOld";
import {getAnaGraficaApi} from "../../../../../services/utils/TicketApiData";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import {clean} from "../../../../../utils/GenericUtils";
import SimpleDialog from "../../../../widgets/dialogs/SimpleDialog";


const AnagraficaStep = ({setStep, tags}) => {
	const classes = BaseStyle();
	let history = useHistory();
	const {getValues, trigger, errors, reset, watch} = useFormContext();
	const anagraficaContext = useContext(AnagraficaContext);
	const appContext = useContext(AppContext)
	const intervistaContext = useContext(IntervistaContext);
	const tamponiContext = useContext(TamponiContext);
	const [submit, setSubmit] = useState(false);
	const [submitIncompleta, setSubmitIncompleta] = useState(false);
	const [submitPrendiInCarico, setSubmitPrendiInCarico] = useState(false);
	let {idSoggetto} = useParams();
	const [created, setCreated] = useState(idSoggetto === "NULL");
	const [openPrendiInCarico, setOpenPrendiInCarico] = useState(false);
	
	const goForward = useCallback(async () => {
		let result = await trigger([
			("nome"),
			("cognome"),
			("cell"),
			("cell2"),
			("email"),
			("domASL"),
			("resASL"),
			("sesso"),
			("dataNascita"),
			("indirizzoResidenza"),
			("indirizzoDomicilio"),
			("comuneNascita"),
		]);
		if (result) {
			setIntervista(getValues(), intervistaContext.dispatch);
			setStep(prevState => ++prevState);
		} else {
			setOpenSnackbar("error", "Controlla bene i dati inseriti!", appContext.dispatch);
		}
	}, [getValues, intervistaContext.dispatch, appContext.dispatch, setStep, trigger])
	
	const cambiaStatoTampone = useCallback((stato) => {
		if (!tamponiContext.state.loadingGetTampone && tamponiContext.state.errorGetTampone === "") {
			setSubmitPrendiInCarico(true);
			updateTampone({
				...tamponiContext.state.tampone,
				stato: stato,
				active: false,
				note: stato === "Preso in carico" ? document.getElementById("note-prendi-in-carico")?.value : tamponiContext.state.tampone?.note + " " + tags.join(" "),
			}, tamponiContext.dispatch)
		}
	}, [tamponiContext.state, tamponiContext.dispatch, tags]);
	
	const aggiornaAnagrafica = useCallback(async () => {
		let result = await trigger([
			("nome"),
			("cognome"),
			("cell"),
			("cell2"),
			("email"),
			("domASL"),
			("resASL"),
			("sesso"),
			("dataNascita"),
			("indirizzoResidenza"),
			("indirizzoResidenzaId"),
			("indirizzoDomicilio"),
			("indirizzoDomicilioId"),
			("comuneNascita"),
		]);
		if (result) {
			if (!anagraficaContext.state.loadingGetAnagrafica && anagraficaContext.state.errorGetAnagrafica === "") {
				let anagraficaPaziente = anagraficaContext.state.anagrafica;
				let newData = clean(getValues());
				setSubmit(true)
				updateAnagrafica(getAnaGraficaApi({
					...anagraficaPaziente, ...newData
				}), idSoggetto === "NULL" ? anagraficaContext.state.anagrafica.idSoggetto : idSoggetto, anagraficaContext.dispatch);
			}
		} else {
			if (errors["indirizzoDomicilioId"]) {
				setOpenSnackbar("error", "Hei, controlla bene di aver inserito un domicilio corretto!", appContext.dispatch);
			} else if (errors?.["indirizzoResidenzaId"]) {
				setOpenSnackbar("error", "Hei, controlla bene di aver inserito una residenza corretta!", appContext.dispatch);
			} else {
				setOpenSnackbar("error", "Controlla bene i dati inseriti!", appContext.dispatch);
			}
		}
	}, [errors, appContext.dispatch, trigger, anagraficaContext.state.loadingGetAnagrafica, anagraficaContext.state.errorGetAnagrafica,
		anagraficaContext.state.anagrafica, getValues, anagraficaContext.dispatch, idSoggetto])
	
	const creaAnagrafica = useCallback(async () => {
		let result = await trigger([
			("nome"),
			("cognome"),
			("codF"),
			("cell"),
			("cell2"),
			("email"),
			("domASL"),
			("resASL"),
			("sesso"),
			("dataNascita"),
			("indirizzoResidenza"),
			("indirizzoResidenzaId"),
			("indirizzoDomicilio"),
			("indirizzoDomicilioId"),
			("comuneNascita"),
		]);
		if (result) {
			setSubmit(true);
			addAnagrafica(getAnaGraficaApi(getValues()), anagraficaContext.dispatch);
		} else {
			setOpenSnackbar("error", "Controlla bene i dati inseriti!", appContext.dispatch);
		}
	}, [getValues, anagraficaContext.dispatch, trigger, appContext.dispatch])
	
	const inviaIntervista = useCallback(() => {
		if (watch("email") && watch("email").length > 0) {
			setSubmitIncompleta(true);
			generateIntervistaIncompleta({
				nome: watch("nome"),
				cognome: watch("cognome"),
				email: watch("email"),
				cellulare: watch("cell"),
				note: "#pazientezero",
				idAnagraficaPazienteZero: idSoggetto,
				sendMail: true,
				sendSMS: false,
				type: "soggetto_positivo"
			}, intervistaContext.dispatch)
		} else {
			setOpenSnackbar("warning", "Hey, non hai indicato nessuna mail per inviare l'intervista al cittadino!", appContext.dispatch)
		}
	}, [intervistaContext.dispatch, watch, appContext.dispatch, idSoggetto])
	
	useEffect(() => {
		if (submitIncompleta && !intervistaContext.state.loadingAddIntervistaIncompleta && intervistaContext.state.errorAddIntervistaIncompleta === "") {
			setSubmitIncompleta(false);
			setOpenSnackbar("success", "La mail è stata inviata al paziente. L'intervista si trova in \"In attesa\" finchè il  cittadino non la compila. Ora segno gestito il tampone.", appContext.dispatch);
			setTimeout(() => {
				cambiaStatoTampone("Gestito");
			}, 2000)
		} else if (submitIncompleta && !intervistaContext.state.loadingAddIntervistaIncompleta && intervistaContext.state.errorAddIntervistaIncompleta !== "") {
			setSubmitIncompleta(false);
			setOpenSnackbar("error", intervistaContext.state.errorAddIntervistaIncompleta, appContext.dispatch)
		}
	}, [submitIncompleta, intervistaContext.state.loadingAddIntervistaIncompleta, intervistaContext.state.errorAddIntervistaIncompleta, appContext.dispatch, cambiaStatoTampone])
	
	useEffect(() => {
		if (submitPrendiInCarico && !tamponiContext.state.loadingUpdateTampone && tamponiContext.state.errorUpdateTampone === "") {
			setSubmitPrendiInCarico(false);
			setOpenSnackbar("success", "Tampone preso in carico correttamente", appContext.dispatch);
			reset({});
			resetGetAnagfrafica(anagraficaContext.dispatch);
			history.goBack();
		} else if (submitPrendiInCarico && !tamponiContext.state.loadingUpdateTampone && tamponiContext.state.errorUpdateTampone !== "") {
			setSubmitPrendiInCarico(false);
			setOpenSnackbar("error", tamponiContext.state.errorUpdateTampone, appContext.dispatch);
		}
	}, [tamponiContext.state.loadingUpdateTampone, tamponiContext.state.errorUpdateTampone, history, appContext.dispatch, submitPrendiInCarico, reset, anagraficaContext.dispatch])
	
	useEffect(() => {
		if (submit && !anagraficaContext.state.loadingUpdateAnagrafica && anagraficaContext.state.errorUpdateAnagrafica === "") {
			setSubmit(false);
			setCreated(false);
			setOpenSnackbar("success", "Anagrafica aggiornata con successo", appContext.dispatch)
		} else if (submit && !anagraficaContext.state.loadingUpdateAnagrafica && anagraficaContext.state.errorUpdateAnagrafica.length > 1) {
			setSubmit(false);
			setOpenSnackbar("error", anagraficaContext.state.errorUpdateAnagrafica, appContext.dispatch)
		}
	}, [anagraficaContext.state.loadingUpdateAnagrafica, anagraficaContext.state.errorUpdateAnagrafica,
		appContext.dispatch, submit])
	
	useEffect(() => {
		if (submit && !anagraficaContext.state.loadingAddAnagrafica && anagraficaContext.state.errorAddAnagrafica === "") {
			setSubmit(false);
			setCreated(false);
			setOpenSnackbar("success", "Anagrafica creata con successo", appContext.dispatch)
		} else if (submit && !anagraficaContext.state.loadingGetAnagrafica && anagraficaContext.state.errorGetAnagrafica === "") {
			setSubmit(false);
			setCreated(false);
			setOpenSnackbar("success", "Anagrafica già esistente aggiornata", appContext.dispatch)
		} else if (submit && !anagraficaContext.state.loadingAddAnagrafica && anagraficaContext.state.errorAddAnagrafica.length > 1) {
			setSubmit(false);
			setOpenSnackbar("error", anagraficaContext.state.errorAddAnagrafica, appContext.dispatch)
		}
	}, [anagraficaContext.state.loadingAddAnagrafica, anagraficaContext.state.errorAddAnagrafica,
		anagraficaContext.state.loadingGetAnagrafica, anagraficaContext.state.errorGetAnagrafica, appContext.dispatch, submit])
	
	return (
		<React.Fragment>
			<Backdrop open={submit || submitIncompleta || submitPrendiInCarico} className={classes.backdrop}>
				<CircularProgress/>
			</Backdrop>
			<AccordionDetails>
				<Grid container spacing={3}>
					{
						idSoggetto !== "NULL" && anagraficaContext.state.loadingGetAnagrafica ? <Skeleton/> :
							idSoggetto !== "NULL" && anagraficaContext.state.errorGetAnagrafica ? "err.." :
								idSoggetto === "NULL" ? <AnagraficaCompleta classes={classes} intro={"false"} moreInfo={true}/> :
									<AnagraficaCompleta classes={classes} intro={"false"} moreInfo={true}
									                    anagrafica={anagraficaContext.state.anagrafica}/>}
					<Grid item xs={12}>
						<Alert severity="info" style={{borderRadius: 24, margin: 4}}>
							<AlertTitle><b>Hey!</b></AlertTitle>
							Hai controllato di aver inserito correttamente gli indirizzi? E il numero di telefono? Non deve esserci il
							+39 davanti. Il sesso? Hai inserito il comune di nascita? Lo trovi nel codice fiscale <i>(es:
							RNDNRC95M03<b
								style={{color: "#F00"}}>D205</b>T, dove D205 è il codice del comune di nascita.)</i><br/>
							Più dati inserisci ora della persona e più sarà facile per chi dovrà gestirla in futuro.
						</Alert>
					</Grid>
				</Grid>
			</AccordionDetails>
			<AccordionActions>
				<Tooltip title={"Torna al passo precedente"}>
					<Button size={"small"} variant={"text"}
					        style={{borderRadius: 24}}
					        className={classes.roundButton} onClick={() => setStep(0)}>
						<b>Torna indietro</b>
					</Button>
				</Tooltip>
				<Tooltip
					title={"Invia al cittadino: Se presente una mail invia al cittadino un link per fargliela compilare in autonomia."}>
					<Button size={"small"} className={classes.roundButton} variant={"contained"} disableElevation
					        color={"secondary"}
					        style={{borderRadius: 24}}
					        onClick={() => inviaIntervista()} disabled={submit}>
						<b>Invia al cittadino</b>
					</Button>
				</Tooltip>
				<Tooltip
					title={"Prendi in carico: indica il tampone con lo stato \"Preso in carico\" e dovrai comunque gestirlo più avanti. Usa questa funzione nel caso in cui un paziente non risponde al telefono o non è disponibile all'intervista."}>
					<Button size={"small"} className={classes.roundButton} variant={"contained"} disableElevation
					        color={"secondary"}
					        style={{borderRadius: 24}}
					        onClick={() => setOpenPrendiInCarico(true)} disabled={submit}>
						<b>Prendi in carico</b>
					</Button>
				</Tooltip>
				<Tooltip
					title={"Segna il tampone con stato \"Gestito\" e ti fa tornare alla visualizzazione dei tamponi. Usa questa funzione nel caso in cui il  paziente non sia di tua competenza."}>
					<Button size={"small"} className={classes.roundButton} variant={"contained"} disableElevation
					        color={"secondary"}
					        style={{borderRadius: 24}}
					        onClick={() => cambiaStatoTampone("Gestito")} disabled={submit}>
						<b>Segna gestito</b>
					</Button>
				</Tooltip>
				{
					created ?
						<Tooltip
							title={"Crea anagrafica del paziente"}>
							<Button size={"small"} className={classes.roundButton}
							        variant={"contained"} disableElevation
							        style={{borderRadius: 24}}
							        onClick={creaAnagrafica} disabled={submit} color={"secondary"}>
								<b>Crea anagrafica</b>
							</Button>
						</Tooltip> :
						<Tooltip
							title={"Aggiorna anagrafica del paziente"}>
							<Button size={"small"} className={classes.roundButton}
							        variant={"contained"} disableElevation
							        style={{borderRadius: 24}}
							        onClick={aggiornaAnagrafica} disabled={submit} color={"secondary"}>
								<b>Aggiorna anagrafica</b>
							</Button>
						</Tooltip>
				}
				<Tooltip title={"Prosegui con il passo successivo"}>
					<Button size={"small"} color={"primary"} variant={"contained"}
					        disableElevation
					        style={{borderRadius: 24}}
					        className={classes.roundButton}
					        onClick={goForward}>
						<b>Prosegui</b>
					</Button>
				</Tooltip>
			</AccordionActions>
			
			{
				openPrendiInCarico &&
				<SimpleDialog
					open={openPrendiInCarico}
					handleClose={() => setOpenPrendiInCarico(!openPrendiInCarico)}
					title={"Qual'è il motivo per cui vuoi prendere in carico?"}
					maxWidth={"md"}
					content={
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<TextField id={"note-prendi-in-carico"} rows={3} multiline={true} variant={"outlined"} label={"Note"}
								           fullWidth/>
							</Grid>
						</Grid>
					}
					actions={
						<DialogActions>
							<Button size={"small"} variant={"contained"} disableElevation color={"primary"}
							        onClick={() => cambiaStatoTampone("Preso in carico")}
							        style={{borderRadius: 24}}>
								<b>Conferma</b>
							</Button>
						</DialogActions>
					}
				/>
			}
		</React.Fragment>
	);
};

export default React.memo(AnagraficaStep);
